import React from "react";
import { PatternFormat } from "react-number-format";

interface ICuiText {
  value?: number | string;
  [key: string]: any;
}

const CuiText = ({ value = "", ...otherProps }: ICuiText) => {
  return (
    <PatternFormat
      id="cui"
      displayType={"text"}
      value={value}
      valueIsNumericString
      format={"##-########-#"}
      {...otherProps}
    />
  );
};

export default CuiText;
